exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-check[data-v-6c43ae82]{width:24%;text-align:center;cursor:pointer}.radio-check .text[data-v-6c43ae82]{display:block;padding-top:10px}input[type=radio][data-v-6c43ae82]{display:none}@media (max-width:767px){.radio-check[data-v-6c43ae82]{width:100%}}", ""]);

// exports
